<header [ngClass]="profileName" id="page-topbar">
  <div #navbarHeader class="navbar-header">
    <div class="scroll-container">
      <div [ngClass]="{'d-flex': scrollOnOff}"
           class="btn-scroll-container scroll-left align-self-center">
        <button (click)="scrollTab('left')" class="btn btn-soft-light" type="button">
          <font-awesome [cssClass]="'font-size-14'" [icon]="'fa-regular fa-chevron-left'"></font-awesome>
        </button>
      </div>
    </div>

    <!-- ticket tab area -->
    <div #tabSetEl [ngClass]="{'pl-8px': !scrollOnOff}" class="top-container" id="topContainer">
      <tabset [ngClass]="{ 'none-tab': tabs?.length < 1 }"
              [style.max-width]="(navbarHeader.offsetWidth - 358) - topRightWidth + 'px'">
        <tab (deselect)="tab.active = false"
             (selectTab)="selectTab($event, i)"
             *ngFor="let tab of tabs; let i = index"
             [active]="tab.active">
          <ng-template tabHeading>
            <div class="tab-title-box">
              <div class="tab-title">
                <span *ngIf="!tab.ticketNo; else ticketView" class="ticket-no">{{ tab.menu.label | translate }}</span>
                <ng-template #ticketView>
                  <span class="ticket-no">
                    {{ tab.title }}
                    <font-awesome *ngIf="tab?.isEdit" [cssClass]="'title-circle'" [icon]="'fa-solid fa-circle'">
                    </font-awesome>
                  </span>
                </ng-template>
              </div>
              <div (click)="closeTab(tab)" *ngIf="tabs.length !== 1" class="tab-close">
                <font-awesome *ngIf="tab.active" [color]="'color-white'" [icon]="'fa-solid fa-xmark'"></font-awesome>
                <font-awesome *ngIf="!tab.active" [icon]="'fa-solid fa-xmark'"></font-awesome>
              </div>
            </div>
          </ng-template>
        </tab>
      </tabset>
    </div>

    <div class="scroll-container">
      <div [ngClass]="{'d-flex': scrollOnOff}"
           class="btn-scroll-container scroll-right align-self-center">
        <button (click)="scrollTab('right')" class="btn btn-soft-light" type="button">
          <font-awesome [cssClass]="'font-size-14'" [icon]="'fa-regular fa-chevron-right'"></font-awesome>
        </button>
      </div>
    </div>

    <div class="top-etc">

      <div [ngClass]="{disableButton: isAdminViewerRole}" class="btn-add-container">
        <button (click)="addTabTicket()" [disabled]="isAdminViewerRole" class="btn btn-soft-light p-0" type="button">
          <font-awesome [icon]="'fa-regular fa-plus'"></font-awesome>&nbsp;Create New Ticket
        </button>
      </div>

      <div class="d-flex justify-content-end top-right-container">
        <ng-container *ngIf="showHelpIcon">
          <font-awesome (click)="showHelpModal()"
                        [cssClass]="'font-size-20 text-primary'"
                        [icon]="'fa-regular fa-question-circle'"
                        class="helpIcon">
          </font-awesome>
        </ng-container>
        <div #dropdown="bs-dropdown" *ngIf="companies.length > 1" [insideClick]="true" class="dropdown d-inline-block"
             dropdown placement="bottom left">
          <div class="wd-150px mr-12px">
            <button (click)="openDropdown()" aria-controls="dropdown-basic" class="btn header-item icon" dropdownToggle
                    type="button">
              <div class="d-flex">
                <span class="ml-4px"><img alt="{{currentCompany.country}} flag image" class="flag"
                                          src="assets/img/{{currentCompany.image}}"></span>
                <span class="header-company-name">{{ currentCompany.code }}</span>
                <span class="header-company-name">{{ currentCompany.name }}</span>
                <span class="ml-8px mr-4px padding-top-5"><font-awesome [cssClass]="'font-size-18'"
                                                                        [icon]="'fa-regular fa-chevron-down'"
                                                                        class="d-flex"></font-awesome></span>
              </div>
            </button>
          </div>
          <div *dropdownMenu class="dropdown-menu dropdown-menu-md p-0 dropdown-menu-right">
            <div (click)="selectCompanyAndReload(company.code)"
                 *ngFor="let company of companies; let i=index;"
                 class="d-flex header-company-selector"
            >
              <span class="ml-4px"><img alt="{{company.country}} flag image" class="flag"
                                        src="assets/img/{{company.image}}"></span>
              <span class="header-company-name">{{ company.code }}</span>
              <span class="header-company-name">{{ company.name }}</span>
            </div>
          </div>
        </div>

        <!--  user info start    -->
        <div class="dropdown d-inline-block" dropdown>
          <button aria-controls="dropdown-basic" class="btn header-item user text-start d-flex align-items-center"
                  dropdownToggle id="page-header-user-dropdown"
                  type="button">

          <span class="d-none d-sm-block user-item-desc">
            <dp-avatar [displayType]="'circle'" [naming]="myInfo | displayName" [size]="34"></dp-avatar>
          </span>
          </button>
          <div *dropdownMenu class="dropdown-menu dropdown-menu-end pt-0" style="width: 216px;">
            <div class="p-3 bg-primary border-bottom">
              <h6 *ngIf="myInfo.firstName" class="mb-0 text-white">{{ myInfo | displayName }}</h6>
              <p class="mb-0 font-size-11 text-white-50 fw-semibold">{{ myInfo.username }}</p>
            </div>
            <a (click)="editUserInfo()" class="dropdown-item" href="javascript: void(0);">
              <i class="mdi mdi-account text-muted font-size-16 align-middle me-1"></i>
              <span class="align-middle">Profile</span>
            </a>
            <a (click)="registerMFA()" class="dropdown-item" href="javascript: void(0);">
              <i class="mdi mdi-logout text-muted font-size-16 align-middle me-1"></i>
              <span class="align-middle">Register MFA</span>
            </a>
            <a (click)="logout($event)" class="dropdown-item" href="javascript: void(0);">
              <i class="mdi mdi-logout text-muted font-size-16 align-middle me-1"></i>
              <span class="align-middle">Logout</span>
            </a>
          </div>
        </div>
        <!--  user info end    -->
      </div>
    </div>

  </div>
</header>
